import {
    STEP,
    SEE_MORE_BUTTON,
    POINTER_EVENTS,
    NWFCLS_GRID,
    DATA_TOUR_STEP_MAPPER,
    MEASURE_LIST_TOP,
    CLOSE_PROBE_DETAILS,
} from '../../constants/reading/DemoModeConstants';
import { isInWidthViewport } from '../shared/demoModeUtils';

export const collapseActivitesSteps = stepId => {
    if (stepId === STEP[40] || stepId === STEP[39] || stepId === STEP[38]) {
        const seeMoreButtonElement = document.querySelector(SEE_MORE_BUTTON);
        if (seeMoreButtonElement && seeMoreButtonElement.innerText === 'See activities')
            seeMoreButtonElement.click();
    }
};

export const clickSeeLessDetails = stepId => {
    if (stepId === STEP[37]) {
        const seeMoreButtonElement = document.querySelector(SEE_MORE_BUTTON);
        if (seeMoreButtonElement) {
            seeMoreButtonElement.style.setProperty(POINTER_EVENTS, 'auto');
        }
        if (seeMoreButtonElement && seeMoreButtonElement.innerText === 'See less') {
            seeMoreButtonElement.click();
        }
    }
};

const scrollToCenter = targetElement => {
    if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        const targetTop = rect.top + window.scrollY;
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const scrollToY = targetTop - windowHeight / 2;
        window.scrollTo({
            top: scrollToY,
            behavior: 'instant',
        });
    }
};

// set selected elements styles to default on tooltip close
export const resetElementsStyles = () => {
    const elProbeDetailsClose = document.querySelector(`[data-tour-step="${CLOSE_PROBE_DETAILS}"`);
    elProbeDetailsClose?.style?.setProperty(POINTER_EVENTS, 'auto');
};

export const updateInteraction = stepId => {
    const elOverlayShadow = document.querySelector('#demo-tooltips > div.amp-styles > svg > path');
    const elProbeDetailsClose = document.querySelector(`[data-tour-step="${CLOSE_PROBE_DETAILS}"`);
    const elNwfclsGrid = document.querySelector(
        `[data-tour-step="${DATA_TOUR_STEP_MAPPER[NWFCLS_GRID]}"]`,
    );
    const elMeasureList = document.querySelector(`[data-tour-step="${MEASURE_LIST_TOP}"]`);
    switch (stepId.length > 0) {
        case STEP[13] === stepId:
            elProbeDetailsClose.style.setProperty(POINTER_EVENTS, 'none');
            break;
        case STEP[14] === stepId:
        case STEP[16] === stepId:
            elOverlayShadow.style.setProperty(POINTER_EVENTS, 'auto');
            elProbeDetailsClose.style.setProperty(POINTER_EVENTS, 'auto');
            break;
        case STEP[15] === stepId:
            elProbeDetailsClose.style.setProperty(POINTER_EVENTS, 'none');
            elOverlayShadow.style.setProperty(POINTER_EVENTS, 'unset');
            break;
        case STEP[32] === stepId:
            elMeasureList.style.setProperty(POINTER_EVENTS, 'none');
            elNwfclsGrid.style.setProperty(POINTER_EVENTS, 'auto');
            break;
        case STEP[33] === stepId:
            elNwfclsGrid.style.setProperty(POINTER_EVENTS, 'none');
            elMeasureList.style.setProperty(POINTER_EVENTS, 'auto');
            break;
        case STEP[31] === stepId:
        case STEP[34] === stepId:
            if (elNwfclsGrid) {
                elNwfclsGrid.style.setProperty(POINTER_EVENTS, 'auto');
            }
            if (elMeasureList) {
                elMeasureList.style.setProperty(POINTER_EVENTS, 'auto');
            }

            break;
        default:
    }
};

export const customScrollTo = step => {
    const el = document.querySelector(`[data-tour-step="${step.element}"]`);
    scrollToCenter(el);
};

export const awaitElPromise = (stepId, step, resolve) => {
    let retries = 0;
    const intervalId = setInterval(() => {
        retries += 1;
        clickSeeLessDetails(stepId);
        collapseActivitesSteps(stepId);

        let el;

        // wait the for probe-detail to appear on the page
        if (step.element === 'probe-detail') {
            el = document.querySelector(`.entered[data-tour-step="${step.element}"]`);
        } else {
            el = document.querySelector(`[data-tour-step="${step.element}"]`);
        }

        if (el && isInWidthViewport(el)) {
            clearInterval(intervalId);
            resolve();
        } else if (retries >= 18) {
            // Maximum number of retries
            Promise.reject(new Error('Element not found after multiple attempts.'));
            clearInterval(intervalId);
        }
    }, 500);
};
